import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {User} from "../types/user";

const initial_state:User = {
    id: 0,
    email: "Non connecté",
    roles: [],
    nom_affichage: "Non connecté",
    nom_famille: "Non connecté",
    tel: "Non connecté",
    notif_push: null,
    statut: "Non connecté",
    canaux_resolution_alertes: [],
    timezone: null,
    last_login_token: "undefined"
};
export const userSlice = createSlice({
    name: "user",
    initialState:initial_state as User,
    reducers: {
        addUser: (state, action:PayloadAction<{message:string, user:User}>) => {
            state = action.payload.user
            return state
        },
        changeTimezone: (state, action:PayloadAction<{timezone:number|null}>) => {
            state.timezone = action.payload.timezone
            return state
        },
        deleteUser: (state, action:PayloadAction<void>) => {
            state = initial_state;
            return state;
        }
    }
})

export const {addUser, deleteUser, changeTimezone} = userSlice.actions;